'use strict';

var videoAccountsTypes = require('./videoAccountsTypes');

var ENUMS = {
  bookingType: require('./bookingPolicy'),
  acceptableUserCities: require('./acceptableUserCities'),
  additionalGuestPolicy: require('./additionalGuestPolicy'),
  ambiance: require('./ambiance'),
  analyticsEvents: require('./analyticsEvents'),
  authorizedClient: require('./authorizedClient'),
  bookingRequestState: require('./bookingRequestState'),
  cancellationPolicy: require('./cancellationPolicy'),
  capacityStyles: require('./capacityStyles'),
  styleCapacity: require('./styleCapacity'),
  cities: require("./cities"),
  concierge: require('./concierge'),
  cuisineTypes: require('./cuisineTypes'),
  currencies: require('./currencies'),
  eventType: require('./eventType'),
  extraHourPolicy: require('./extraHourPolicy'),
  intermediatePaymentOrdinals: require("./intermediatePayments"),
  leadInterest: require('./leadInterest'),
  majorCities: require('./majorCities'),
  landingPageCities: require('./landingPageCities'),
  menuTypes: require('./menuTypes'),
  metaDescriptions: require('./metaDescriptions'),
  neighborhoods: require('./neighborhoods'),
  newsletters: require('./newsletters'),
  payment: require('./payment'),
  paymentStates: require('./paymentStates'),
  payout: require('./payout'),
  priceType: require('./priceType'),
  proposalCreatedThrough: require('./proposal-created-through'),
  referral: require('./referral'),
  resolutionTransaction: require('./resolutionTransaction'),
  searchLocations: require('./searchLocations'),
  searchPriceRanges: require('./searchPriceRanges'),
  sfdcOwners: require('./sfdcOwners'),
  sidebarCitiesList: require('./sidebarCitieslist'),
  spaceAddons: require('./spaceAddons'),
  spaceAmenities: require('./spaceAmenities'),
  spacePrivacy: require('./spacePrivacy'),
  spaceTypes: require('./spaceTypes'),
  stateCodes: require('./stateCodes'),
  taxTypes: require('./taxTypes'),
  userStatuses: require('./userStatuses'),
  userTypes: require('./userTypes'),
  validationErrors: require('./validationErrors'),
  venueAddons: require('./venueAddons'),
  venueAmenities: require('./venueAmenities'),
  venueStatuses: require('./venueStatuses'),
  venueTypes: require('./venueTypes'),
  videoTitles: require('./videoTitles'),
  veroEvents: require('./veroEvents'),
  weekDays: require('./weekDays'),
  landingPageVenues: require('./landingPageVenues'),
  leadStatuses: require('./leadStatuses'),
  defaultCurrency: require('./defaultCurrency'),
  cityNumbers: require('./cityNumbers'),
  locationDisplay: require('./locationDisplay'),
  venueAdmin: require('./venueAdmin'),
  liteProfileAccolades: require('./liteProfileAccolades'),
  liteProfileRatingWebsites: require('./liteProfileRatingWebsites'),
  receiptAttachmentTypes: require('./receiptAttachmentTypes'),
  videoAccountsTypes: require('./videoAccountsTypes'),
  magicLink: require('./magicLink')
};

module.exports = ENUMS;